const getCoordinatesForTurf = (entity: { geoJSONData: any }) => [
  entity.geoJSONData.features[0].geometry.coordinates.map((e: string) => {
    const r = e.split(' ');
    return [Number(r[0]), Number(r[1])];
  }),
];

export default getCoordinatesForTurf;
